export interface Config {
    apiKey: string,
    region: string,
    endpointId: string,
    speechRecognitionLanguage: string
}

export enum SpeechEvents {
    START = 'start',
    STOP = 'stop',
    NEW_SESSION = 'new_session'
}

export enum RecordingToolTip {
    START_RECORDING = 'Start Recording',
    STOP_RECORDING = 'Stop Recording',
    INITIALIZING = 'Initializing',
    PROCESSING = 'Processing',
    RESUME = 'Resume'
}